import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';
import { Header } from '@/components/header';
import { Partners } from '@/components/partners';
import Cta from '@/components/cta';
import { Footer } from '@/components/footer';

export default function TermsConditions() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sectionList = [
    { key: 'legalNotice', label: t('terms.legalNotice.title'), id: 'section-legalNotice' },
    { key: 'general', label: t('terms.general.title'), id: 'section-general' },
    { key: 'intellectualProperty', label: t('terms.intellectualProperty.title'), id: 'section-intellectualProperty' },
    { key: 'personalData', label: t('terms.personalData.title'), id: 'section-personalData' },
    { key: 'liability', label: t('terms.liability.title'), id: 'section-liability' },
    { key: 'applicableLaw', label: t('terms.applicableLaw.title'), id: 'section-applicableLaw' },
  ];
  const [activeSection, setActiveSection] = useState(sectionList[0].id);

  useEffect(() => {
    const handleScroll = () => {
      let current = sectionList[0].id;
      for (const section of sectionList) {
        const el = document.getElementById(section.id);
        if (el && window.scrollY + 120 >= el.offsetTop) {
          current = section.id;
        }
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionList]);

  return (
    <>
    <Header />
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row gap-10">
        {/* Sidebar */}
        <aside className="hidden md:block md:w-64 flex-shrink-0 pt-8 sticky top-24 h-fit self-start">
          <nav>
            <ul className="space-y-2">
              {sectionList.map(section => (
                <li key={section.id}>
                  <button
                    className={`w-full text-left px-2 py-2 rounded transition font-medium text-base ${activeSection === section.id ? 'text-blue-700 font-bold underline' : 'text-gray-700 hover:text-blue-700'}`}
                    onClick={() => {
                      const el = document.getElementById(section.id);
                      if (el) {
                        window.scrollTo({ top: el.offsetTop - 20, behavior: 'auto' });
                      }
                    }}
                  >
                    {section.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
        {/* Main Content */}
        <div className="flex-1 max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-10 text-black">
            {t('terms.title')}
          </h1>
          <section className="mb-10" id="section-legalNotice">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.legalNotice.title')}</h2>
            <p className="mb-4 text-black">{t('terms.legalNotice.sitePublished')}</p>
            <p className="mb-4 text-black">{t('terms.legalNotice.publicationDirector')}</p>
            <p className="mb-4 text-black">{t('terms.legalNotice.contact')}</p>
            <p className="mb-4 text-black">{t('terms.legalNotice.hosting')}</p>
            <p className="mb-8 text-black">{t('terms.legalNotice.credits')}</p>
          </section>
          <section className="mb-10" id="section-general">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.general.title')}</h2>
            <p className="mb-4 text-black">{t('terms.general.access')}</p>
            <p className="mb-4 text-black">{t('terms.general.modifications')}</p>
            <p className="mb-8 text-black">{t('terms.general.availability')}</p>
          </section>
          <section className="mb-10" id="section-intellectualProperty">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.intellectualProperty.title')}</h2>
            <p className="mb-4 text-black">{t('terms.intellectualProperty.protection')}</p>
            <p className="mb-4 text-black">{t('terms.intellectualProperty.reproduction')}</p>
            <p className="mb-4 text-black">{t('terms.intellectualProperty.links')}</p>
            <p className="mb-8 text-black">{t('terms.intellectualProperty.thirdParty')}</p>
          </section>
          <section className="mb-10" id="section-personalData">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.personalData.title')}</h2>
            <p className="mb-4 text-black">
              {t('terms.personalData.collection')}
              <Link href="/privacy-policy" className="text-blue-700 hover:underline ml-1">
                {t('terms.personalData.privacyPolicy')}
              </Link>.
            </p>
          </section>
          <section className="mb-10" id="section-liability">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.liability.title')}</h2>
            <p className="mb-4 text-black">{t('terms.liability.accuracy')}</p>
            <p className="mb-8 text-black">{t('terms.liability.damages')}</p>
          </section>
          <section className="mb-10" id="section-applicableLaw">
            <h2 className="text-2xl font-semibold mt-8 mb-4 text-black">{t('terms.applicableLaw.title')}</h2>
            <p className="mb-8 text-black">{t('terms.applicableLaw.description')}</p>
          </section>
          <p className="text-sm text-gray-500 mt-12 text-center">
            {t('terms.lastUpdated')}
          </p>
        </div>
      </div>
    </div>
     <Partners />
     <Cta />
     <Footer />
     </>
  );
}
